import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Unidade de Medida',
  path: '/merenda/merunidade',
  name: 'merunidade',
  component: () => import('@/views/merenda/merunidade/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.UNIDADEDEMEDIDANOVO_MENU_1000600399],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Unidade de Medida',
  path: '/merenda/merunidade/cadastro/:id?',
  parent: 'merunidade',
  name: 'merunidade_create',
  component: () => import('@/views/merenda/merunidade/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.UNIDADEDEMEDIDANOVO_MENU_1000600399],
  },
  goesToMenu: true,
 },
]
